const listeners = new Set();
let pending = 0;
/** Invalidation only: account data and credentials never travel between surfaces. */
export const accountPresentationChanges = {
    pending: () => pending > 0,
    subscribe(listener) {
        listeners.add(listener);
        return () => { listeners.delete(listener); };
    },
    begin() {
        pending++;
        for (const listener of listeners)
            listener();
        let finished = false;
        return () => {
            if (finished)
                return;
            finished = true;
            pending--;
            for (const listener of listeners)
                listener();
        };
    },
};
//# sourceMappingURL=copilot-account-presentation.js.map